import { c as _c } from "react/compiler-runtime";
import { Flag } from '@7f-ui/components/flag/flag';
export function ExperienceCardFlag() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute top-4 left-4 text-primary"><Flag>Termin anfragen</Flag></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}